import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DateMomentPipe } from './dateMoment.pipe';
import { DateTimeRangePipe } from './dateTimeRange.pipe';
import { DurationPipe } from './duration.pipe';
import { DateService } from './date.service';
import { TimeMomentPipe } from './timeMoment.pipe';
import { DateIgnoreOffsetPipe } from 'libraries/date/date-ignore-offset.pipe';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        DateMomentPipe,
        DateTimeRangePipe,
        DurationPipe,
        TimeMomentPipe,
        DateIgnoreOffsetPipe,
    ],
    exports: [
        DateMomentPipe,
        DateTimeRangePipe,
        DurationPipe,
        TimeMomentPipe,
        DateIgnoreOffsetPipe,
    ],
    providers: [
        DateService,
        DateMomentPipe,
        DateTimeRangePipe,
        DurationPipe,
        TimeMomentPipe,
    ]
})
export class DatePipeModule {
}
